import { createFileRoute } from "@tanstack/react-router";

import { useTableDisplayState } from "@/components/DataTable";
import { VStack } from "@/components/Layout";

import PageHeader from "./-components/PageHeader";
import Table from "./-components/Table";
import TableHeader from "./-components/TableHeader";
import useGetExternalItSaasAppIntegrations from "./-queries/useGetExternalItSaasAppIntegrations";

export const Route = createFileRoute("/_staff/devices/external-it-saas/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { data, isPending } = useGetExternalItSaasAppIntegrations();
  const displayState = useTableDisplayState(isPending, data?.groups ?? []);

  return (
    <VStack className="mx-auto w-[1000px] py-12 gap-8">
      <PageHeader />

      <VStack className="gap-6">
        <TableHeader />
        <Table
          data={data ?? { groups: [], totalCount: 0 }}
          displayState={displayState}
        />
      </VStack>
    </VStack>
  );
}
